import type { TFunction } from 'i18next';
import type { GridColDef } from '@mui/x-data-grid-premium';

import { showDeleteDialog } from 'app/main/components';
import { ViewTableUtils } from 'app/main/components/page-layouts';

import KpisUtils from './components/KpisUtils';
import { showKpisGoalsEditDialog } from './components/KpisGoalsEditDialog';

type KpisGoalsTableColumnsType = (params: { settings: any; t: TFunction; updateRefresh: VoidFunction }) => GridColDef[];

const getKpisGoalsTableColumns: KpisGoalsTableColumnsType = ({ settings, t, updateRefresh }) => {
	const columns: GridColDef[] = [
		{
			field: 'kpis_title',
			headerName: t('DETAILS_KPIS_GOALS_FIELD_KPI'),
			minWidth: 200,
			flex: 1,
			renderCell: ViewTableUtils.renderCellWithTooltip,
			hideable: false
		},
		{
			field: 'kpgl_aggregation_module_title',
			headerName: t('DETAILS_KPIS_GOALS_FIELD_AGGREGATION_TITLE'),
			minWidth: 200,
			flex: 2,
			renderCell: ({ value, row }) =>
				ViewTableUtils.renderCellWithTooltip({
					value,
					to: { module: row.kpis_aggregation_module, uid: row.kpgl_aggregation_module_value }
				}),
			hideable: false
		},
		{
			field: 'kpgl_d_from',
			headerName: t('DETAILS_KPIS_GOALS_FIELD_DATE_FROM'),
			minWidth: 120,
			renderCell: ViewTableUtils.renderDate,
			hideable: false
		},
		{
			field: 'kpgl_d_to',
			headerName: t('DETAILS_KPIS_GOALS_FIELD_DATE_TO'),
			minWidth: 120,
			renderCell: ViewTableUtils.renderDate,
			hideable: false
		},
		{
			field: 'kpgl_value',
			type: 'number',
			headerName: t('DETAILS_KPIS_GOALS_FIELD_TARGET_VALUE'),
			minWidth: 150,
			renderCell: KpisUtils.renderKpiTarget,
			hideable: false
		},
		{
			field: 'kgst_title',
			headerName: t('DETAILS_KPIS_GOALS_FIELD_STATUS'),
			minWidth: 150,
			renderCell: ({ value, row }) => ViewTableUtils.renderSquareChip({ value, backgroundColor: row.kgst_color })
		},
		{
			type: 'actions',
			field: 'actions',
			width: 40,
			renderCell: ({ id, row }) =>
				ViewTableUtils.renderMenu({
					items: [
						{
							name: 'VIEW_ITEM_BUTTON_EDIT',
							icon: 'edit',
							hidden: ({ authorizer }) => authorizer.cannot('update', 'sys_kpis_goals'),
							action: ({ dispatch, model }) => {
								dispatch(showKpisGoalsEditDialog({ model, updateRefresh }));
							}
						},
						{
							name: 'VIEW_ITEM_BUTTON_DELETE',
							icon: 'delete',
							hidden: ({ authorizer }) => authorizer.cannot('delete', 'sys_kpis_goals'),
							action: ({ dispatch, model }) => {
								dispatch(
									showDeleteDialog({
										module: 'sys_kpis_goals',
										id: model.kpgl_uid,
										hardDelete: true,
										updateRefresh
									})
								);
							}
						}
					],
					buttonProps: { settings, model: row, updateRefresh }
				}),
			sortable: false
		}
	];

	return columns;
};

export default getKpisGoalsTableColumns;
